(function ($) {


    // load plugins
    require('../jquery-plugins/bootstrap-datepicker.min.js');
    require('../jquery-plugins/wickedpicker.min.js');

    //load translates
    require('../jquery-plugins/bootstrap-datepicker.de.min.js');
    require('../jquery-plugins/bootstrap-datepicker.pl.min.js');


    /**
     *
     *
     *
     * POŁĄCZENIA LINIOWE
     *
     *
     *
     *
     */
    let checkin_date, checkin_div, checkin_dp,
        checkout_date, checkout_div, checkout_dp;

// function for udpating displayed date in button
    function update() {
        if (checkin_date !== undefined) {
            //  $('#display-checkin').html(checkin_date.toLocaleDateString());
        }
        if (checkout_date !== undefined) {
            // $('#display-checkout').html(checkout_date.toLocaleDateString());
        }
    }

    var today = new Date();
    var todayString = today.getMonth() + '/' + (today.getDate() - 1) + '' + today.getFullYear();

// create checkin datepicker
    checkin_div = $('.liniowe-odjazd').datepicker({
        todayBtn: false,
        language: $("body").attr("data-lang"),
        orientation: "bottom auto",
        format: "dd.mm.yyyy",
        startDate: "today",
        // datesDisabled: ['1/1/1970', todayString],
        autoclose: true,
        beforeShowDay: function(date) {
            if (checkout_date !== undefined) {
                // disabled date selection for day after checkout date
                if (date > checkout_date) {
                    return false;
                }
                // display checkout date in checkin datepicker
                if (date.getDate() === checkout_date.getDate() &&
                    date.getMonth() === checkout_date.getMonth() &&
                    date.getFullYear() === checkout_date.getFullYear()) {
                    return {
                        classes: 'is-selected'
                    };
                }
            }
            // display range dates in checkin datepicker
            if (checkin_date !== undefined && checkout_date !== undefined) {
                if (date > checkin_date && date < checkout_date) {
                    return {
                        classes: 'is-between'
                    };
                }
            }
            // display checkin date
            if (checkin_date !== undefined) {
                if (date.getDate() === checkin_date.getDate() &&
                    date.getMonth() === checkin_date.getMonth() &&
                    date.getFullYear() === checkin_date.getFullYear()) {
                    return {
                        classes: 'active'
                    };
                }
            }
            return true;
        }
    });

// save checkin datepicker for later
    checkin_dp = checkin_div.data('datepicker');

    checkin_div.on('changeDate', (event) => {
        // save checkin date
        checkin_date = event.date;
        // update checkout datepicker so range dates are displayed
        checkout_dp.update();
        checkin_dp.update();
        update();
    });

// create checkout datepicker
    checkout_div = $('.liniowe-powrot').datepicker({
        autoclose: true,
        todayBtn: false,
        language: $("body").attr("data-lang"),
        orientation: "bottom auto",
        format: "dd.mm.yyyy",
        beforeShowDay: function(date) {
            if (checkin_date !== undefined) {
                // disabled date selection for day before checkin date
                if (date < checkin_date) {
                    return false;
                }
                // display checkin date in checkout datepicker
                if (date.getDate() === checkin_date.getDate() &&
                    date.getMonth() === checkin_date.getMonth() &&
                    date.getFullYear() === checkin_date.getFullYear()) {
                    return {
                        classes: 'is-selected'
                    };
                }
            }
            // display range dates in checkout datepicker
            if (checkin_date !== undefined && checkout_date !== undefined) {
                if (date > checkin_date && date < checkout_date) {
                    return {
                        classes: 'is-between'
                    };
                }
            }
            // display checkout date
            if (checkout_date !== undefined) {
                if (date.getDate() === checkout_date.getDate() &&
                    date.getMonth() === checkout_date.getMonth() &&
                    date.getFullYear() === checkout_date.getFullYear()) {
                    return {
                        classes: 'active'
                    };
                }
            }
            return true;
        }
    });


    checkout_dp = checkout_div.data('datepicker');
    checkout_div.on('changeDate', (event) => {
        // save checkout date
        checkout_date = event.date;
        // update checkin datepicker so range dates are displayed
        checkin_dp.update();
        checkout_dp.update();
        update();
    });







    /**
     *
     *
     *
     * BUSINESS TAXI
     *
     *
     *
     *
     */



    let checkin_date2, checkin_div2, checkin_dp2;


    var today = new Date();
    var todayString = today.getMonth() + '/' + (today.getDate() - 1) + '' + today.getFullYear();

// create checkin datepicker
    checkin_div2 = $('.businesstaxi-odjazd').datepicker({
        todayBtn: false,
        language: $("body").attr("data-lang"),
        orientation: "bottom auto",
        startDate: "today",
        format: "dd.mm.yyyy",
        ignoreReadonly: true,
        // datesDisabled: ['1/1/1970', todayString],
        autoclose: true,
        beforeShowDay: function(date) {
            // display checkin date
            if (checkin_date2 !== undefined) {
                if (date.getDate() === checkin_date2.getDate() &&
                    date.getMonth() === checkin_date2.getMonth() &&
                    date.getFullYear() === checkin_date2.getFullYear()) {
                    return {
                        classes: 'active'
                    };
                }
            }
            return true;
        }
    });

// save checkin datepicker for later
    checkin_dp2 = checkin_div2.data('datepicker');


    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        $(".hidden-touch-device").remove();
    } else {
        $(".visible-touch-device").remove();
    }





    /**
     *
     *
     *
     * BUSINESS TAXI
     *
     *
     *
     *
     */



    let checkin_date3, checkin_div3, checkin_dp3;


    var today = new Date();
    var todayString = today.getMonth() + '/' + (today.getDate() - 1) + '' + today.getFullYear();

// create checkin datepicker
    checkin_div3 = $('.familytaxi-odjazd').datepicker({
        todayBtn: false,
        language: $("body").attr("data-lang"),
        orientation: "bottom auto",
        startDate: "today",
        format: "dd.mm.yyyy",
        // datesDisabled: ['1/1/1970', todayString],
        autoclose: true,
        beforeShowDay: function(date) {
            // display checkin date
            if (checkin_date3 !== undefined) {
                if (date.getDate() === checkin_date3.getDate() &&
                    date.getMonth() === checkin_date3.getMonth() &&
                    date.getFullYear() === checkin_date3.getFullYear()) {
                    return {
                        classes: 'active'
                    };
                }
            }
            return true;
        }
    });

// save checkin datepicker for later
    checkin_dp3 = checkin_div3.data('datepicker');


    let checkin_date4, checkin_div4, checkin_dp4;
    checkin_div4 = $('.berbus-odjazd').datepicker({
        todayBtn: false,
        language: $("body").attr("data-lang"),
        orientation: "bottom auto",
        startDate: "today",
        format: "dd.mm.yyyy",
        ignoreReadonly: true,
        autoclose: true,
        beforeShowDay: function(date) {
            if (checkin_date4 !== undefined) {
                if (date.getDate() === checkin_date4.getDate() &&
                    date.getMonth() === checkin_date4.getMonth() &&
                    date.getFullYear() === checkin_date4.getFullYear()) {
                    return {
                        classes: 'active'
                    };
                }
            }
            return true;
        }
    });
    checkin_dp4 = checkin_div3.data('datepicker');


})(jQuery);